export enum TooltipStatus {
    INIT,
    IDLE,
    SHOWING,
    HIDING,
    ACTIVE,
    CLICKED
}
